
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20professional%20business%20office%20environment%20with%20diverse%20team%20of%20professionals%20collaborating%20in%20bright%20contemporary%20workspace%20with%20glass%20walls%20natural%20lighting%20and%20sleek%20minimalist%20design%20aesthetic%20showing%20innovation%20and%20corporate%20excellence&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Professional Recruitment Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Connecting Talent with Opportunity
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">
            Your trusted recruitment partner delivering exceptional talent solutions across industries. We bridge the gap between ambitious professionals and forward-thinking companies.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#solutions"
              className="inline-flex items-center px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line mr-2"></i>
              Find Talent
            </a>
            <a
              href="#services"
              className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white text-lg font-semibold rounded-lg hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-briefcase-4-line mr-2"></i>
              Explore Careers
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white/70"></i>
        </div>
      </div>
    </section>
  );
}
